import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: [],
}

export const calendarDatesSlice: any = createSlice({
    name: 'CALENDAR_DATES',
    initialState,
    reducers: {
        setStateCalendarDates: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setStateCalendarDates } = calendarDatesSlice.actions

export default calendarDatesSlice.reducer
